<template>
  <div>
    <TitlePage :title="$t('view')+' '+$t('customer')"></TitlePage>

    <div class="d-flex justify-end mb-2" v-if="isSuperAdmin && item.email">
      <ExternalPlatformLink :href="marketingAppUserUrl(item.email)" icon="mdi-account-search-outline">Apri l'utente nel marketing</ExternalPlatformLink>
    </div>

    <CustomerStats :user-id="$route.params.id" />

    <v-layout wrap>
      <v-flex md12 class="d-flex pt-5 pb-5">
        <v-chip color="primary" label small text-color="white">{{$t('genericInfo')}}</v-chip>
      </v-flex>

      <v-flex md5 class="pl-4 pr-4">
        <v-text-field :label="$t('name')" v-model="item.name" readonly></v-text-field>
      </v-flex>

      <v-flex md5 class="pl-4 pr-4">
        <v-text-field :label="$t('surname')" v-model="item.surname" readonly></v-text-field>
      </v-flex>

      <v-flex md2 class="pl-4 pr-4">
        <v-switch v-model="item.active" inset :label="$t('status')" dense hide-details readonly></v-switch>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('email')" v-model="item.email" readonly :prepend-icon="(item.email_verified)?'mdi-check-decagram':''"></v-text-field>
      </v-flex>

      <v-flex md4 class="pl-4 pr-4">
        <v-text-field :label="$t('phone')" v-model="item.phone" readonly :prepend-icon="(item.phone_verified)?'mdi-check-decagram':''"></v-text-field>
      </v-flex>

      <v-flex md12 class="pl-4 pr-4">
        <v-text-field :label="$t('addressComplete')" v-model="item.address_complete" readonly></v-text-field>
      </v-flex>

      <v-flex md12 class="d-flex pt-5">
        <v-chip color="primary" label small text-color="white">{{$t('financialInfo')}}</v-chip>
      </v-flex>

      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('company')" v-model="item.financial_info && item.financial_info.company" readonly></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('address')" v-model="item.financial_info && item.financial_info.address" readonly></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('city')" v-model="item.financial_info && item.financial_info.city" readonly></v-text-field>
      </v-flex>
      <v-flex md2 class="pl-4 pr-4">
        <v-text-field :label="$t('province')" v-model="item.financial_info && item.financial_info.province" readonly></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('postal_code')" v-model="item.financial_info && item.financial_info.postal_code" readonly></v-text-field>
      </v-flex>
      <v-flex md1 class="pl-4 pr-4">
        <v-text-field :label="$t('country')" v-model="item.financial_info && item.financial_info.country" readonly></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('vat_code')" v-model="item.financial_info && item.financial_info.vat_code" readonly></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('fiscal_code')" v-model="item.financial_info && item.financial_info.fiscal_code" readonly></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('sdi_code')" v-model="item.financial_info && item.financial_info.sdi_code" readonly></v-text-field>
      </v-flex>
      <v-flex md3 class="pl-4 pr-4">
        <v-text-field :label="$t('pec_address')" v-model="item.financial_info && item.financial_info.pec_address" readonly></v-text-field>
      </v-flex>

      <v-flex md12 class="pt-10 d-flex">
        <v-divider class="marg-title"></v-divider>
      </v-flex>
      <v-flex md12 class="pt-5 d-flex buttons-group-mobile">
        <v-btn elevation="2" color="" class="mr-auto" @click="$router.go(-1)">
          <v-icon left>mdi-keyboard-backspace</v-icon>
          {{ $t('back') }}
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import TitlePage from "@/components/utils/TitlePage";
import ExternalPlatformLink from "@/components/utils/ExternalPlatformLink";
import {marketingAppUserUrl} from "@/utils/platforms";
import {mapGetters, mapMutations, mapActions} from 'vuex';
import { getReliabilityScore, getReliabilityColor } from '@/utils/reliability';
import CustomerStats from "@/components/customers/CustomerStats.vue";

export default {
  name: "DetailsCustomer",
  components: {CustomerStats, TitlePage, ExternalPlatformLink},
  computed:{
    ...mapGetters({
      'getUser':'user/getUser'
    }),
    // UCAMP-87 plan 9: solo i superadmin accedono al marketing
    isSuperAdmin() {
      return !!(this.getUser && this.getUser.super_admin)
    },
  },
  data() {
    return {
      pathBookings: '/bookings?user_id=',
      pathCancellations: '/cancellations?user_id=',
      pathPromoCode: '/promo-codes?user_id=',
      pathBlacklists: '/blacklists?search=',
      stats: {},
      item: {},
      count_promo_code: 0,
      userForReliability: {},
    };
  },
  async created(){
    this.setLoading(true);
    let fetchItem = await this.detailsItem(this.$route.params)

    this.item = Object.assign({},fetchItem.result.user)
    this.stats = Object.assign({},fetchItem.result.bookings)
    this.count_promo_code = fetchItem.result.count_promo_code ? fetchItem.result.count_promo_code : 0

    this.userForReliability = {
      _id: this.item._id,
      name: this.item.name,
      surname: this.item.name,
      phone: this.item.phone,
      email: this.item.email,
      active: this.item.active,
      image: this.item.image,
      bookings_completed: this.item.bookings_completed,
      created_at: this.item.created_at,
      updated_at: this.item.updated_at,
      bookings_count_completed : this.stats.bookings_count_completed,
      bookings_count_canceled : this.stats.bookings_count_canceled,
      bookings_count_to_be_confirmed : this.stats.bookings_count_to_be_confirmed,
      bookings_count_booked : this.stats.bookings_count_booked,
      bookings_count_interrupted : this.stats.bookings_count_interrupted,
      count_blacklist : this.item.blacklists && this.item.blacklists.length > 0 ? this.item.blacklists.filter(obj => obj.status === 'active').length : 0,
      count_promo_code : this.count_promo_code,
      phone_verified: this.item.phone_verified,
      email_verified: this.item.email_verified,
    }

    this.setLoading(false);
  },
  methods: {
    marketingAppUserUrl,
    ...mapMutations({
      'setLoading': 'settings/setLoading',
      'setNotification': 'settings/setNotification',
    }),
    ...mapActions({
      'detailsItem':'customers/details',
    }),

  },
  mounted() {

  },
}
</script>

<style scoped>

</style>